import { Modal } from "@mantine/core"
import { Button } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

export const ConfirmBeforeClosingModal = ({
	opened,
	setOpened,
	onConfirmClose,
}) => {
	const { t } = useTranslation()

	return (
		<Modal
			opened={opened}
			onClose={() => null}
			withCloseButton={false}
			zIndex={100000}
			centered
			radius={20}
			title={
				<div style={{ fontWeight: "600", color: "#333" }}>
					{t("components.confirm_modal.unsaved_changes")}
				</div>
			}
		>
			<div style={{ padding: "0.5rem" }}>
				<p>
					{t(
						"components.confirm_modal.are_you_sure_you_want_to_discard_the_changes_made",
					)}
				</p>

				<div style={{ marginTop: "1rem" }}>
					<Button fullWidth destructive onClick={onConfirmClose}>
						{t(
							"components.confirm_modal.discard_changes_and_close",
						)}
					</Button>
				</div>
				<div style={{ marginTop: "0.5rem" }}>
					<Button fullWidth onClick={() => setOpened(false)}>
						{t("components.confirm_modal.continue_editing")}
					</Button>
				</div>
			</div>
		</Modal>
	)
}
